var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRetailinline = function SvgRetailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "retail_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 143 143"
    },
    viewBox: "0 0 143 143"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".retail_inline_svg__st0,.retail_inline_svg__st1{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m108.142 118.486 8.675-3.622 8.669 20.763-8.674 3.622zM142.4 114.1l-6.7 6.6-35.9-34.9-.4-.4-9-8.8V63.5l9 8.8.4.4z",
    className: "retail_inline_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4 114v9.5h-40l9.7-9.4h13.2z",
    className: "retail_inline_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m125.3 114.3-6.2 6-3.2 3.2-.3.2-3.7 3.7-15.4 15-6.1-6.2v-1l9.4-9.2 2.3-2.3.3-.2 9.4-9.2z",
    className: "retail_inline_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8 72.7v63.5h-9.4V63.5l9 8.8z",
    className: "retail_inline_svg__st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2 90.6c0-5.3-4.3-9.5-9.5-9.5-5.3 0-9.5 4.3-9.5 9.5 0 5.3 4.3 9.5 9.5 9.5 5.3 0 9.5-4.2 9.5-9.5M39 90.6c0-5.3-4.3-9.5-9.5-9.5-5.3 0-9.5 4.3-9.5 9.5 0 5.3 4.3 9.5 9.5 9.5s9.5-4.2 9.5-9.5M10 76.2h72.1l-5.9-9.4H10zM17.1.6H.6L6.5 10h10.6z",
    className: "retail_inline_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m15.8 76.2 10.8-21.5-5.3-10.5-16 32zM20.6.6H10l28.4 56.7h10.5zM40.6 19.5l4.6 9.4h51.7v-9.4z",
    className: "retail_inline_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 19.5 80.1 47.8H38.4l6.2 9.5h41.3l18.7-37.8z",
    className: "retail_inline_svg__st1"
  })));
};
export default SvgRetailinline;